// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageLoading_wrapper__RD1Bz"};